import React from 'react';
import { Accessibility } from 'app/graphql/__generated__/types/contento';
import Link from 'next/link';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { languageSupportClick } from '../../utils/statistics/customEvents';
import { A11yLinksList, A11yListItem, A11yLink, A11yIcon } from './AccessibilityLinks.styles';
import { SvgIcons } from '../SvgIcon/SvgIcon';

type Props = {
    isVisible?: boolean;
};

const AccessibilityLinks = ({ isVisible }: Props): JSX.Element => {
    if (!isVisible) {
        return null;
    }

    const trackA11yLinkClick = (type: Accessibility): void => {
        trackCustomEvent(languageSupportClick(type));
    };

    return (
        <A11yLinksList>
            <A11yListItem data-rt="a11y-audio-description">
                <Link href="/syntolkat" passHref>
                    <A11yLink onClick={() => trackA11yLinkClick(Accessibility.AudioDescribed)}>
                        <A11yIcon aria-hidden="true" icon={SvgIcons.SIGHT} width={18} />
                        Syntolkat
                    </A11yLink>
                </Link>
            </A11yListItem>
            <A11yListItem data-rt="a11y-sign-language">
                <Link href="/teckensprak" passHref>
                    <A11yLink onClick={() => trackA11yLinkClick(Accessibility.SignInterpreted)}>
                        <A11yIcon aria-hidden="true" icon={SvgIcons.SIGN_LANGUAGE} width={18} />
                        Teckenspråk
                    </A11yLink>
                </Link>
            </A11yListItem>
        </A11yLinksList>
    );
};

export default AccessibilityLinks;
